// Content Library

var $currentTextArea;

var $accordionUl;

var $container;

$(document).ready(function() {
	
	// only show content library if text areas are visible
	$(document).on('load click keyup', function() {
		if($('div.multi-form-entry').length && $('div.multi-form-entry').is(':visible') == true ) {
			$('#content-library-toolbar').show();
		}
		if ($('textarea.field-input').length && $('textarea.field-input').is(':visible') == false ) {
			$('#content-library-toolbar').hide();
		} else {			
			$('#content-library-toolbar').show();
		}
	});
	
	if ($('textarea.field-input').is(':visible') && $('#content-library-toolbar').length) {
		$('#content-library-toolbar').show();
	}
	
	$accordionUl = $('#library-ul-wrapper');
	
	$container = $('#library-accordion-container');
	
	$('textarea').on('change keyup paste click', function() {
		var $this = $(this);
		$currentTextArea = $this;
	})
	
	$('.toggle-library').on('click', function() {
		$('#content-library').toggle(100);
		$('.library-icon-button').toggle(100);
	});
	
	$accordionUl.on('click', '.insert-content', function() {
		var $this = $(this);
		
		var data = $this.closest('.accordion-content').data('content-id');
		
		if (typeof($currentTextArea) != "undefined" && $currentTextArea !== null && $currentTextArea.is('textarea')) {
			$currentTextArea.focus();
			$currentTextArea[0].scrollIntoView({behavior: "smooth"});

			var caretPos = $currentTextArea[0].selectionStart;
			var text = $currentTextArea.val();
			$.ajax({ 
				url: '/ajax/library/retrieve-content',
				type : "POST",
				contentType : 'application/json',
				data : JSON.stringify({contentId: data})
			}).done(function(result) {
				var resultLength = result[0].length;
				var newCaretPos = resultLength + caretPos;
				$currentTextArea.val(text.substring(0, caretPos) + result[0] + text.substring(caretPos));
				$currentTextArea.prop('selectionEnd', newCaretPos);
			});
		}
	});
	
	$accordionUl.on('click','.copy-content', function() {
		var $this = $(this);
		
		var data = $this.closest('.accordion-content').data('content-id');
		var $wrapper = $('#content-library');
		
		$.ajax({ 
			url : '/ajax/library/retrieve-content',
			type : "POST",
			contentType : 'application/json',
			data : JSON.stringify({contentId: data})
		}).done(function(result) {
			navigator.clipboard.writeText(result[0]);
			$accordionUl.prepend('<p class="library-event-message callout success">Copied to clipboard</p>');
			setTimeout(function() {
				$wrapper.find('.success').remove();
			},2000)
		});
	});
	
	$('#searchLibrary').on('keyup', Foundation.util.throttle(function() {
		var $this = $(this);
		
		var search = $this.val();
		
		$container.addClass('fade-out-load');
		
		$.ajax({
			url : '/ajax/library/search',
			type : 'POST',
			contentType : 'application/json',
			data : JSON.stringify({searchValue: search})
		}).done(function(result) {
			$accordionUl.empty();			
			if (result.numCategories > 0) {
				$accordionUl.append(result.content);		
				$('#library-accordion').foundation();			
			} else {
				$accordionUl.append('<p class="library-event-message alert callout">No results found</p>');
			}
			$container.removeClass('fade-out-load');
		});
		
		// Foundation - throttle the event handler, 500ms
	}, 500));
	
});